export const VEHICLE_COLOR = 'color'
export const VEHICLE_ENGINE = 'engine'
export const VEHICLE_TIRES = 'tires'

export const SIZE_NOT_LISTED_OPTION = 'My tire size isn\'t listed'

export const VEHICLE_CUSTOM_COLOR_LIST = [
  {
    colorDesc: 'White',
    colorId: 'ffffff'
  },
  {
    colorDesc: 'Black',
    colorId: '010000'
  },
  {
    colorDesc: 'Blue',
    colorId: '172e58'
  },
  {
    colorDesc: 'Brown',
    colorId: '623a21'
  },
  {
    colorDesc: 'Gold',
    colorId: 'c9b96e'
  },
  {
    colorDesc: 'Gray',
    colorId: '33363d'
  },
  {
    colorDesc: 'Green',
    colorId: '76b92e'
  },
  {
    colorDesc: 'Orange',
    colorId: 'dc5325'
  },
  {
    colorDesc: 'Purple',
    colorId: 'ae08d8'
  },
  {
    colorDesc: 'Red',
    colorId: 'bb2315'
  },
  {
    colorDesc: 'Silver',
    colorId: 'aaaaaa'
  },
  {
    colorDesc: 'Tan',
    colorId: 'd4cdb0'
  },
  {
    colorDesc: 'Yellow',
    colorId: 'facd0e'
  }
]
